import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex);
const VP = Vue.prototype;

const ORDER_STATUS = Object.freeze({  
                                    "New" : { icon : "ic_order_new_circle_filled", priority : 1 , value : "New" }, 
                                    "Confirmed" : { icon : "ic_order_confirmed_circle_filled", priority : 2 , value : "Confirmed" },
                                    "Preparing" : { icon : "ic_order_preparing_circle_filled", priority : 3 , value : "Preparing" }, 
                                    
                                    "Pack" : { icon : "ic_order_pack_circle_filled", priority : 4 , value : "Pack" }, 
                                    "Ready" : { icon : "ic_order_ready_circle_filled", priority : 5 , value : "Ready" }, 
                                    "Closed": { icon : "ic_order_close_circle_filled", priority : 6 , value : "Closed" },
                                    
                                    "Rejected" : { icon : "ic_order_rejected_circle_filled", priority : 7 , value : "Rejected" }, 
                                    "Cancelled_Customer" : { icon : "ic_order_canceled_customer_circle_filled", priority : 8 , value : "Cancelled_Customer" }, 
                                    "Cancelled_Staff" : { icon : "ic_order_canceled_staff_circle_filled", priority : 9 , value : "Cancelled_Staff" }
                                })

//user
const loginUrl = `/user/login`
const getMe = `/user/me`
const logoutUrl = `/user/logout`
const usersList = `user`//GET
const newUser = `/user` //Post
const editUser = ({_id})=>{ return `/user/${_id}` } //Patch
const deleteUser = ({_id})=>{ return `/user/${_id}` } //Delete
const resetUserPassword = `user/reset` //Post
const setUserPassword = `user/password` //Post
const setOrganization = (_id)=>{ return `user/setOrganization/${_id}` }
const setLocation = ({_id})=>{ return `user/setLocation/${_id}` }

//Order
const getOrders = `/order`  //GET
const getSingleOrder = ({_id}) => `/order/${_id}`  //GET
const updateOrderStatus = ({_id}) => `order/${_id}`    //Patch
const refundOrder = ({_id}) => `order/${_id}/refund`    //POST
const refundOrderAndCancel = ({_id}) => `order/${_id}/refundAndCancel`    //POST

//List86
const list86Get = "/list86";    //GET
const list86Patch = "/list86";    //PATCH

//report
const reportSalesSummary = `/report/salesSummary`
const reportSales = `/report/sales`
const reportItems = `/report/items`
const reportLostSales = `/report/lostSales`
const reportEfficiency = `/report/efficiency`
const reportDashboard = `/report/dashboard`

//organization
const organization = `/organization`
const newOrganization = `/organization` //Post
const editOrganization = ({_id})=>{ return `/organization/${_id}` } //Patch
const deleteOrganization = ({_id})=>{ return `/organization/${_id}` } //Delete

//location
const location = `/location`
const newLocation = `/location` //Post
const editLocation = ({_id})=>{ return `/location/${_id}` } //Patch
const deleteLocation = ({_id})=>{ return `/location/${_id}` } //Delete

//square
const squareSetup = `square/setup`
const squareDone = `square/done`
const squareRevoke = `square/revoke`

//stripe
const stripeCreate = ({locationId})=>{ return `stripe/create/${locationId}` }
const stripeLink = ({accountId})=>{ return `stripe/accountLink/${accountId}` }
const stripeRetrive = ({accountId})=>{ return `stripe/accounts/${accountId}` }
const stripeOAuthLink = `stripe/oAuthLink`
const stripeOAuth = (code) => `stripe/oAuth/${code}`
const stripeRevoke = `stripe/revoke`

//menu
const menuActive = `menu/active`
const menuActiveSave = `menu/active`
const menuActiveRevert = `menu/active/revert`
const menuActivePublish = `menu/active/publish`

const mediaUpload = `/media/upload-menu`    //Post
const mediaGallery = `/media/gallery`       //Get
const mediaDelete = ({_id})=>{ return `/media/${_id}` }    //Delete
const mediaSetClip = ({_id})=>{ return `/media/${_id}` }    //Post

const ARG_USER_CREDENTIAL = "portal_userCredential"
const ARG_MENU_PREVIEW = "portal_menuPreview"
const ARG_USER_DEFAULT_DATA = "portal_default_data"
const ARG_SETTING = "portal_setting"

// eslint-disable-next-line
function setLs(key, data){localStorage.setItem(key, data)}
function getLs(key){ return localStorage.getItem(key)}
// eslint-disable-next-line
function removeLs(key){ localStorage.removeItem(key)}

const state = Vue.observable(
    { 
        userInfo:null,
        selectedOrganization:null,
        selectedLocation:null,
        store: {},
        menus: [],
        items: [],
        cart: [],
        stateOrders:[],
        viewingOrder:null,
        setting: {  notification : { idealTime : 30, isShow : true , playBeep : true } }
    }
);
let renderMenu = ()=>{
    if(getLs(ARG_MENU_PREVIEW) !== null) {
        let menu = getLs(ARG_MENU_PREVIEW);
        menu = JSON.parse(menu);
        state.menus = menu.sections || [];
        state.items = []
        state.menus.forEach(section => {
            section.items.forEach(item => {
                state.items.push(item)
            })
        })
    }            
}
renderMenu();

let setting = ()=>{
    if(getLs(ARG_SETTING) !== null) {
        let setting = getLs(ARG_SETTING);
        setting = JSON.parse(setting);
        state.setting = setting || state.setting
    }
}
setting()

var sourceSalesSummary , sourceSales, sourceItems, sourceLostSales, sourceOrderEfficiency;
var sourceOrganization, sourceLocation;
var sourceNewOrganization, sourceEditOrganization, sourceDeleteOrganization
var sourceNewLocation, sourceEditLocation, sourceDeleteLocation
var sourceNewUser, sourceEditUser, sourceDeleteUser, sourceSetOrganization, sourceSetLocationUser
var sourceSetPassword
var sourceMenuGallery
var sourceMenuActiveSave
var sourceCreateStrip, sourceLinkStrip, sourceRetriveStrip
var sourceGetOrders, sourceGetSingleOrder

export default new Vuex.Store({
    state,
    getters: {
        getUserInfo(state){
            return state.userInfo
        },
        get7Days(){
            return ["Monday","Tuesday","Wednesday","Thursday","Friday","Saturday","Sunday"]
        },
        getCredential(){
            return JSON.parse(getLs(ARG_USER_CREDENTIAL))
        },
        getDefaultData(){
            return JSON.parse(getLs(ARG_USER_DEFAULT_DATA));
        },
        /*-------------------------------------*/
        cartItems(state) {
            return state.cart.map(cartItem => {
                const item = state.items.find(item => item._id == cartItem.item_id);
                let selected_option_names = [];
                let size = [];

                cartItem.selected_options.forEach(selected_option => {
                    selected_option.options.forEach(option => {
                        //console.log("Option", selected_option.size[option])
                        size.push(selected_option.size[option])
                        selected_option_names.push(item.optionGroups[selected_option.option_group].options[option].title);
                    })
                })

                return {
                    item: item,
                    selected_options: cartItem.selected_options,
                    selected_option_names: selected_option_names,
                    size: size,
                    quantity: cartItem.quantity,
                    special_note: cartItem.special_note,
                    total_price: cartItem.total_price
                };
            });
        },
        cartTotal() {
           return { sum: 0, qty: 0 }
        },
        /*-------------------------------------*/
        getOrderStatus() {
            return ORDER_STATUS
        },
        timeZone(state) {
            try {
                return (state.userInfo.location.timeZone || "America/New_York").trim()
            } catch(_) {
                return "America/New_York"
            }
        }
    },
    mutations: {
        setSelectedOrganization(state, organization) {
            state.selectedOrganization = organization
        },
        setSelectedLocation(state, location) {
            state.selectedLocation = location
        },
        updateStripeAccount(state, accountId){
            if(!state.userInfo.location.stripe) {
                state.userInfo.location["stripe"] = {}
            }
            if(!state.userInfo.location.stripe.stripeAccount) {
                state.userInfo.location.stripe["stripeAccount"] = accountId;
            }        
        },
        updateUserInfo(state, userInfo){
            state.userInfo = userInfo
        },
        updateStateOrders(state, orders){
            state.stateOrders = orders
        },
        selectViewingOrder(state, viewingOrder) {
            state.viewingOrder = viewingOrder
        },
        updateSettingNotification(state, notification) {
            state.setting["notification"] = notification
            setLs(ARG_SETTING, JSON.stringify(state.setting))
        },
    },
    actions: { // = methods   
        /*-------------------------------------*/      
        setDefaultData(context, defaultData){
            setLs(ARG_USER_DEFAULT_DATA, JSON.stringify(defaultData));
        },
        setMenu(context, menu) {
            setLs(ARG_MENU_PREVIEW, JSON.stringify(menu))
        },
        addItemToCart({state}, cartItem) {
            state.cart.push(cartItem);
        },
        updateCart({state}, obj) {
            const cart = state.cart.find((item, index) => index === obj.cart_index);
            if (cart) {
                cart.total_price = obj.data.total_price;
                cart.quantity = obj.data.quantity;
                cart.special_note = obj.data.special_note;
                cart.selected_options = obj.data.selected_options;
            }
        },
        deleteCartItem({state}, index) {
            state.cart.splice(index, 1);  
        },
        lsOSinOrdering(){},
        customerLog(){},
        renderMenu() {
            renderMenu();
        },        
        /*-------------------------------------*/        
        
        async apiLogin(context, userInfo){
            try{
                const loginRes =  await VP.$http.post(loginUrl, userInfo)                
                if (loginRes.status !== 200) {                    
                    return { status: false , error:loginRes.error}                    
                } 
                //setLs(ARG_USER_CREDENTIAL, JSON.stringify(userInfo))
                const meRes =  await VP.$http.get(getMe)
                if (meRes.status === 200) {
                    context.state.userInfo = meRes.data
                    return { status: true , res:meRes.data}                   
                }else{
                    return { status: false , error:meRes.error}                                        
                }                
            }catch(e){
                return { status: false , error:e}
            }
        },        
        async apiMe(context){
            try{
                const meRes =  await VP.$http.get(getMe)
                if (meRes.status === 200) {
                    context.state.userInfo = meRes.data      
                    return { status: true , res:meRes.data}                   
                }else{
                    return { status: false , error:meRes.error}                                        
                }                
            }catch(e){
                return { status: false , error:e}
            }
        },
        apiSetUserPassword(context, _reqData){
            if(sourceSetPassword){
                sourceSetPassword.cancel();
            }            
            sourceSetPassword = VP.$axios.CancelToken.source();       
            return apiPromise(VP.$http
                            .patch(setUserPassword, _reqData, {cancelToken: sourceSetPassword.token}))
        },
        apilogOut(){
            apiPromise(VP.$http.post(logoutUrl, {})).then(()=>{ window.location.reload() })
            removeLs(ARG_MENU_PREVIEW)
           // window.location.reload()
           // context.state.userInfo = null
        },

        apiGetOrders(context, _reqData) {
            if(sourceGetOrders) {
                sourceGetOrders.cancel()
            }
            sourceGetOrders = VP.$axios.CancelToken.source();
            return apiPromise(VP.$http.get(getOrders, { params: _reqData, cancelToken: sourceGetOrders.token }))
        },
        apiGetSingleOrder(context, _reqData){
            if(sourceGetSingleOrder) {
                sourceGetSingleOrder.cancel()
            }
            sourceGetSingleOrder = VP.$axios.CancelToken.source();
            return apiPromise(VP.$http.get(getSingleOrder(_reqData), { cancelToken: sourceGetSingleOrder.token }))
        },
        apiUpdateOrderStatus(context, _reqData) {
            return apiPromise(VP.$http.patch(updateOrderStatus(_reqData), _reqData))  
        },
        apiRefundOrder(context, _reqData) {
            return apiPromise(VP.$http.post(refundOrder(_reqData), ))  
        },
        apiRefundOrderAndCancel(context, _reqData) {
            return apiPromise(VP.$http.post(refundOrderAndCancel(_reqData), ))  
        },

        apiSetOrganization(context, _reqData){
            if(sourceSetOrganization){
                sourceSetOrganization.cancel();
            }
            sourceSetOrganization = VP.$axios.CancelToken.source(); 
            return apiPromise(VP.$http
                            .post(setOrganization(_reqData), {cancelToken: sourceSetOrganization.token}))    
        },
        apiSetLocation(context, _reqData) {
            if(sourceSetLocationUser){
                sourceSetLocationUser.cancel();
            }
            sourceSetLocationUser = VP.$axios.CancelToken.source(); 
            return apiPromise(VP.$http
                            .post(setLocation(_reqData), {cancelToken: sourceSetLocationUser.token}))    
        },

        apiGetList86() {
            return apiPromise(VP.$http.get(list86Get))
        },
        apiUpdateList86(context, _reqData) {
            return apiPromise(VP.$http.patch(list86Patch, _reqData))
        },
        
        apiSalesSummaryReport(context, _reqData){
            let reqData = new Object()
            reqData.start = _reqData.start.format("YYYY-MM-DD")
            reqData.end = _reqData.end.format("YYYY-MM-DD")  
            reqData.location = _reqData.location==null?'':_reqData.location._id

            if(sourceSalesSummary){
               sourceSalesSummary.cancel();
            }
            sourceSalesSummary = VP.$axios.CancelToken.source();

            return apiPromise(VP.$http
                   .get(reportSalesSummary, {params : reqData,  cancelToken: sourceSalesSummary.token}))
                
        },
        apiSalesReport(context, _reqData){
            let reqData = new Object()
            reqData.start = _reqData.start.format("YYYY-MM-DD")
            reqData.end = _reqData.end.format("YYYY-MM-DD")  
            reqData.location = _reqData.location==null?'':_reqData.location._id

            if(sourceSales){
               sourceSales.cancel();
             }
             sourceSales = VP.$axios.CancelToken.source();

            return apiPromise(VP.$http
                    .get(reportSales, {params : reqData,  cancelToken: sourceSales.token}))
        },
        apiItemsReport(context, _reqData){
            let reqData = new Object()
            reqData.start = _reqData.start.format("YYYY-MM-DD")
            reqData.end = _reqData.end.format("YYYY-MM-DD")  
            reqData.location = _reqData.location==null?'':_reqData.location._id

            if(sourceItems){
                sourceItems.cancel();
             }
             sourceItems = VP.$axios.CancelToken.source();

            return apiPromise(VP.$http
                     .get(reportItems, {params : reqData,  cancelToken: sourceItems.token}))
        },
        apiOrderEfficiencyReport(context, _reqData){
            let reqData = new Object()
            reqData.start = _reqData.start.format("YYYY-MM-DD")
            reqData.end = _reqData.end.format("YYYY-MM-DD")
            reqData.location = _reqData.location==null?'':_reqData.location._id

            if(sourceOrderEfficiency){
               sourceOrderEfficiency.cancel();
            }
            sourceOrderEfficiency = VP.$axios.CancelToken.source();            
            return apiPromise(VP.$http
                      .get(reportEfficiency, {params : reqData, cancelToken: sourceOrderEfficiency.token}))            
        },
        apiLostSalesReport(context, _reqData){
            let reqData = new Object()
            reqData.start = _reqData.start.format("YYYY-MM-DD")
            reqData.end = _reqData.end.format("YYYY-MM-DD")
            reqData.location = _reqData.location==null?'':_reqData.location._id
            
            if(sourceLostSales){
                sourceLostSales.cancel();
            }
            sourceLostSales = VP.$axios.CancelToken.source();            
            return apiPromise(VP.$http
                            .get(reportLostSales, {params : reqData, cancelToken: sourceLostSales.token}))            
        },
        apiDashboardReport(){
            return apiPromise(VP.$http.get(reportDashboard))  
        },

        apiOrganization() {
            if(sourceOrganization){
                sourceOrganization.cancel();
            }            
            sourceOrganization = VP.$axios.CancelToken.source();            
            return apiPromise(VP.$http
                            .get(organization))//, {cancelToken: sourceOrganization.token}))
        },
       
        apiNewOrganization(context, _reqData){
            if(sourceNewOrganization){
                sourceNewOrganization.cancel();
            }            
            sourceNewOrganization = VP.$axios.CancelToken.source();          
            return apiPromise(VP.$http
                            .post(newOrganization, _reqData, {cancelToken: sourceNewOrganization.token}))
        },
        apiEditOrganization(context, _reqData){
            if(sourceEditOrganization){
                sourceEditOrganization.cancel();
            }            
            sourceEditOrganization = VP.$axios.CancelToken.source();      
            return apiPromise(VP.$http
                            .patch(editOrganization(_reqData), _reqData, {cancelToken: sourceEditOrganization.token}))
        },
        apiDeleteOrganization(context, _reqData){
            if(sourceDeleteOrganization){
                sourceDeleteOrganization.cancel();
            }            
            sourceDeleteOrganization = VP.$axios.CancelToken.source();    
            return apiPromise(VP.$http
                            .delete(deleteOrganization(_reqData), {cancelToken: sourceDeleteOrganization.token}))
        },
        
        apiNewLocation(context, _reqData){
            if(sourceNewLocation){
                sourceNewLocation.cancel();
            }            
            sourceNewLocation = VP.$axios.CancelToken.source();  
            return apiPromise(VP.$http
                            .post(newLocation, _reqData, {cancelToken: sourceNewLocation.token}))
        },
        apiEditLocation(context, _reqData){
            if(sourceEditLocation){
                sourceEditLocation.cancel();
            }            
            sourceEditLocation = VP.$axios.CancelToken.source();         
            return apiPromise(VP.$http
                            .patch(editLocation(_reqData), _reqData, {cancelToken: sourceEditLocation.token}))
        },
        apiDeleteLocation(context, _reqData){
            if(sourceDeleteLocation){
                sourceDeleteLocation.cancel();
            }            
            sourceDeleteLocation = VP.$axios.CancelToken.source();        
            return apiPromise(VP.$http
                            .delete(deleteLocation(_reqData), {cancelToken: sourceDeleteLocation.token}))
        },

        apiNewUser(context, _reqData){
            if(sourceNewUser){
                sourceNewUser.cancel();
            }            
            sourceNewUser = VP.$axios.CancelToken.source();        
            return apiPromise(VP.$http
                            .post(newUser, _reqData, {cancelToken: sourceNewUser.token}))
        },
        apiEditUser(context, _reqData){
            if(sourceEditUser){
                sourceEditUser.cancel();
            }            
            sourceEditUser = VP.$axios.CancelToken.source();      
            return apiPromise(VP.$http
                            .patch(editUser(_reqData), _reqData, {cancelToken: sourceEditUser.token}))
        },
        apiDeleteUser(context, _reqData){
            if(sourceDeleteUser){
                sourceDeleteUser.cancel();
            }            
            sourceDeleteUser = VP.$axios.CancelToken.source();  
            return apiPromise(VP.$http
                            .delete(deleteUser(_reqData), {cancelToken: sourceDeleteUser.token}))
        },
        apiResetUserPassword(context, _reqData){
            return apiPromise(VP.$http.post(resetUserPassword, _reqData))
        },

        apiLocation(context, _reqData) {   
            if(sourceLocation){
                sourceLocation.cancel();
            }
            sourceLocation = VP.$axios.CancelToken.source();                        
            return apiPromise(VP.$http.get(location, {  params: _reqData }))//{cancelToken: sourceLocation.token}
        },
        apiSquareSetup() {
            return apiPromise(VP.$http.get(squareSetup))
        },
        apiSquareDone(context, _reqData) {
            let reqData = new Object()
            reqData.code = _reqData.code
            return apiPromise(VP.$http.get(squareDone, {params : reqData}))
        },
        apiSquareRevoke() {
            return apiPromise(VP.$http.post(squareRevoke))
        },
      
        apiMenuActive() {
            return apiPromise(VP.$http.get(menuActive))
        },
        apiMenuActiveSave(context, _reqData) {
            if(sourceMenuActiveSave){
                sourceMenuActiveSave.cancel();
            }            
            sourceMenuActiveSave = VP.$axios.CancelToken.source();
            return apiPromise(VP.$http.patch(menuActiveSave, _reqData, {cancelToken: sourceMenuActiveSave.token}))
        },
        apiMenuActiveRevert(){
            return apiPromise(VP.$http.post(menuActiveRevert))
        },
        apiMenuActivePublish(){
            return apiPromise(VP.$http.post(menuActivePublish))            
        },
    
        apiUsersList(){            
            return apiPromise(VP.$http.get(usersList))
        },
        
        apiStripeOAuthLink(){
            return apiPromise(VP.$http.get(stripeOAuthLink));
        },
        apiStripeOAuth(context, _reqData){
            return apiPromise(VP.$http.post(stripeOAuth(_reqData.code)));
        },
        apiStripeRevoke(){
            return apiPromise(VP.$http.post(stripeRevoke));
        },

        apiCreateStripeAccount(context, _reqData){
            if(sourceCreateStrip){
                sourceCreateStrip.cancel();
            }
            sourceCreateStrip = VP.$axios.CancelToken.source();
            return apiPromise(VP.$http.post(stripeCreate(_reqData), {cancelToken: sourceCreateStrip.token}))
        },
        apiLinkStripeAccount(context, _reqData){
            if(sourceLinkStrip){
                sourceLinkStrip.cancel();
            }
            sourceLinkStrip = VP.$axios.CancelToken.source();
            return apiPromise(VP.$http.post(stripeLink(_reqData), {cancelToken: sourceLinkStrip.token}))
        },
        apiRetriveStripeAccount(context, _reqData){
            if(sourceRetriveStrip){
                sourceRetriveStrip.cancel();
            }
            sourceRetriveStrip = VP.$axios.CancelToken.source();
            return apiPromise(VP.$http.get(stripeRetrive(_reqData), {cancelToken: sourceRetriveStrip.token}))
        },
        apiMediaUpload(context, _reqData) {
            return apiPromise(VP.$http.post(mediaUpload, _reqData, {
                headers: {
                  'Content-Type': 'multipart/form-data'
                }
            }))
        },
        apiMediaGallery(context, _reqData){
            if(sourceMenuGallery){
                sourceMenuGallery.cancel();
            }
            sourceMenuGallery = VP.$axios.CancelToken.source();
            return apiPromise(VP.$http.get(mediaGallery, {params : _reqData,  cancelToken: sourceMenuGallery.token}))
        },
        apiMediaDelete(context, _reqData) {
            return apiPromise(VP.$http.delete(mediaDelete(_reqData)))
        },
        apiMediaSetClip(context, _reqData) {
            return apiPromise(VP.$http.post(mediaSetClip(_reqData), _reqData))
        }
    },
    modules: { // setting and updating the state        
    }
});

var apiPromise = function(call) {
   return new Promise((resolve, reject) => {       
        call.then(response => {
                    if(response.status === 200){
                        resolve({ status: true , res : response.data })
                     }else{                        
                        resolve({ status: false , error : response.error })                                                            
                     }
                }).catch(e => {
                    let msgError = ''
                    if(e && e.response && e.response.data){
                        let errors = e.response.data
                        if(errors instanceof Array){
                            errors.forEach(({msg})=>{
                                msgError += msg + '\n'
                            })
                        } else {
                            msgError = errors                           
                        }
                    }

                    reject({ status: false , error:e , msgError:msgError})
                    if (VP.$axios.isCancel(e)) {
                        console.log('Request canceled', e.message);
                    }else{                        
                        if(e.response && e.response.status === 401) {
                            //window.location.reload()
                        }
                    }
                })
        })
}